import axios from "axios";

export const NOTIFICATION_CHANNEL_TYPES = ["email", "slack", "sms", "front"];

export function readOutboundNotificationConfig(org) {
  const raw = org?.outbound_notification_config;
  const config = raw?.M ?? raw ?? {};
  const channelId = config.channel_id?.S ?? config.channel_id ?? null;
  const policy = config.policy?.S ?? config.policy ?? "allow";

  return {
    channel_id: channelId || null,
    policy: channelId ? policy : null,
  };
}

export function getNotificationChannelOptions(channels) {
  const list = channels?.L ?? channels ?? [];
  return list
    .filter((item) => {
      const type = item?.M?.type?.S ?? item?.type;
      return NOTIFICATION_CHANNEL_TYPES.includes(type);
    })
    .map((item) => {
      const m = item.M ?? item;
      const label = m.label?.S ?? m.label ?? "";
      const displayValue = m.value?.S ?? m.value ?? "";
      const value = m.ch_id?.S ?? m.ch_id;
      return {
        value,
        label: label ? `${label} - ${displayValue}` : displayValue,
      };
    });
}

export function shouldSyncOutboundNotification({
  channelId,
  policy,
  userEnabled,
}) {
  if (!channelId) return false;
  if (policy === "require") return true;
  if (policy === "allow") return !!userEnabled;
  return false;
}

export function normalizeOutboundNotificationConfigForApi(config) {
  if (!config?.channel_id) {
    return { channel_id: null, policy: null };
  }
  return {
    channel_id: config.channel_id,
    policy: config.policy === "require" ? "require" : "allow",
  };
}

export async function completeOutboundCallNotification({
  organizationId,
  callId,
  channel_id,
}) {
  await axios.post(process.env.REACT_APP_BACKEND_URL + "call/complete-call", {
    organizationId,
    callId,
    channel_id,
  });
}
